(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[654],{

/***/ 59900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _home_runner_work_thehub_thehub_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_runner_work_thehub_thehub_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_thehub_thehub_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42283);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36219);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74231);
/* harmony import */ var _styles_modules_Form_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10315);
/* harmony import */ var _styles_modules_Form_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Form_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_6__);











var schema = yup__WEBPACK_IMPORTED_MODULE_5__/* .object */ .Ry().shape({
    email: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().email().required()
});
var RequestAccountForm = function(props) {
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_4__/* .yupResolver */ .X)(schema),
        defaultValues: {
            email: ""
        },
        mode: "all"
    }), register = ref.register, handleSubmit = ref.handleSubmit, formState = ref.formState;
    var errors = formState.errors;
    var onSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_home_runner_work_thehub_thehub_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            return _home_runner_work_thehub_thehub_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        props.onSubmit(data);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
        className: "".concat((_styles_modules_Form_module_scss__WEBPACK_IMPORTED_MODULE_8___default().panel)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "d-flex flex-column content",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("header", {
                    className: "d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            href: "/login",
                            className: "d-flex my-auto",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
                                src: "/static/icons/common/back-arrow.svg",
                                width: 32,
                                height: 32,
                                alt: "Back"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                            className: "".concat((_styles_modules_Form_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["auth-title"])),
                            children: props.title
                        })
                    ]
                }),
                props.requestSuccess && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "mt-5 d-flex flex-column ".concat((_styles_modules_Form_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["success-content"])),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "".concat((_styles_modules_Form_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["success-header"])),
                            children: props.requestSuccess
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "".concat((_styles_modules_Form_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["success-description"])),
                            children: props.requestSuccessDescription
                        })
                    ]
                }),
                !props.requestSuccess && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                    onSubmit: handleSubmit(onSubmit),
                    className: "".concat((_styles_modules_Form_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["auth-container"])),
                    autoComplete: "off",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "".concat((_styles_modules_Form_module_scss__WEBPACK_IMPORTED_MODULE_8___default().description)),
                            children: props.description
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "form-group mb-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                    htmlFor: "email",
                                    className: "form-label",
                                    children: "Email Address"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "form-group__fields",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                            type: "hidden",
                                            autoComplete: "off"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                                            type: "email",
                                            className: "\n                    form-control auth-input\n                    ".concat(errors.email ? "is-invalid" : "", "\n                    ").concat(formState.isValid ? "is-valid" : "", "\n                  ")
                                        }, register("email")), {
                                            autoFocus: true,
                                            defaultValue: "",
                                            autoComplete: "off"
                                        }))
                                    ]
                                }),
                                errors.email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    className: "form-error",
                                    children: errors.email.message
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "auth-message-container",
                                    children: props.requestError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        className: "form-group__fields--error",
                                        children: props.requestError
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "".concat((_styles_modules_Form_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["form-action"])),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                type: "submit",
                                className: "btn btn-purple auth-button mb-3",
                                disabled: !formState.isValid,
                                children: "Send Instructions"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RequestAccountForm);


/***/ }),

/***/ 58944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layouts_Layout; }
});

// UNUSED EXPORTS: VerticalAlign

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./styles/modules/Layout.module.scss
var Layout_module = __webpack_require__(87383);
var Layout_module_default = /*#__PURE__*/__webpack_require__.n(Layout_module);
// EXTERNAL MODULE: ./components/context/AppContext.tsx + 6 modules
var AppContext = __webpack_require__(90995);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/scripts/Userback.tsx



var Userback = function(param) {
    var userEmail = param.userEmail, userName = param.userName, customButton = param.customButton;
    var email = userEmail || "";
    var name = userName || "";
    var customConfig = "";
    if (customButton) {
        customConfig = '\n      var body = document.body;\n      window.Userback.on_open = () => {\n        body.classList.add("open");\n      };\n      window.Userback.on_close = () => {\n        body.classList.remove("open");\n      };\n      Userback.before_send = function() {\n        body.classList.remove("open");\n      };\n    ';
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
            id: "user-back",
            strategy: "lazyOnload",
            children: "\n        window.Userback = window.Userback || {};\n        ".concat(customConfig, '\n        Userback.access_token = "32636|59886|fNDPDbiTeNkA7ELMFXQxLdHp2";\n        (function (d) {\n          var s = d.createElement("script");\n          s.async = true;\n          s.src = "https://static.userback.io/widget/v1.js";\n          (d.head || d.body).appendChild(s);\n        })(document);\n          window.Userback.name = "').concat(name, '";\n          window.Userback.email = "').concat(email, '";\n      ')
        })
    });
};


// EXTERNAL MODULE: ./node_modules/lodash/capitalize.js
var capitalize = __webpack_require__(48403);
var capitalize_default = /*#__PURE__*/__webpack_require__.n(capitalize);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./styles/modules/TopNav.module.scss
var TopNav_module = __webpack_require__(31757);
var TopNav_module_default = /*#__PURE__*/__webpack_require__.n(TopNav_module);
// EXTERNAL MODULE: ./node_modules/pong-react-components/assets/images/icons/products/icon-companynetwork.svg
var icon_companynetwork = __webpack_require__(52998);
var icon_companynetwork_default = /*#__PURE__*/__webpack_require__.n(icon_companynetwork);
// EXTERNAL MODULE: ./node_modules/pong-react-components/assets/images/icons/products/icon-product-connect.svg
var icon_product_connect = __webpack_require__(60736);
var icon_product_connect_default = /*#__PURE__*/__webpack_require__.n(icon_product_connect);
// EXTERNAL MODULE: ./node_modules/pong-react-components/assets/images/icons/products/icon-product-prism.svg
var icon_product_prism = __webpack_require__(81067);
var icon_product_prism_default = /*#__PURE__*/__webpack_require__.n(icon_product_prism);
// EXTERNAL MODULE: ./node_modules/pong-react-components/assets/images/icons/products/icon-product-spaces.svg
var icon_product_spaces = __webpack_require__(37996);
var icon_product_spaces_default = /*#__PURE__*/__webpack_require__.n(icon_product_spaces);
// EXTERNAL MODULE: ./node_modules/pong-react-components/assets/images/icons/products/icon-product-studio.svg
var icon_product_studio = __webpack_require__(54782);
var icon_product_studio_default = /*#__PURE__*/__webpack_require__.n(icon_product_studio);
// EXTERNAL MODULE: ./node_modules/pong-react-components/assets/images/icons/products/icon-product-chat.svg
var icon_product_chat = __webpack_require__(89695);
var icon_product_chat_default = /*#__PURE__*/__webpack_require__.n(icon_product_chat);
// EXTERNAL MODULE: ./node_modules/pong-react-components/assets/images/icons/products/icon-product-datagraph.svg
var icon_product_datagraph = __webpack_require__(88135);
var icon_product_datagraph_default = /*#__PURE__*/__webpack_require__.n(icon_product_datagraph);
;// CONCATENATED MODULE: ./helpers/bundle.ts







var getIcon = function(bundleName) {
    switch(bundleName){
        case "apps":
            return (icon_companynetwork_default());
        case "connect":
            return (icon_product_connect_default());
        case "enterprise":
            return (icon_product_prism_default());
        case "spaces":
        case "space":
            return (icon_product_spaces_default());
        case "studio":
            return (icon_product_studio_default());
        case "chat":
            return (icon_product_chat_default());
        case "datagraph":
            return (icon_product_datagraph_default());
    }
};
var getTitle = function(bundleName) {
    switch(bundleName){
        case "apps":
            return "Pong Network";
        case "connect":
            return "Connect";
        case "enterprise":
            return "Pong Platform";
        case "spaces":
        case "space":
            return "Pong Prism";
        case "studio":
            return "Pong Studio";
        case "chat":
            return "Pong Circles";
        case "datagraph":
            return "CBI Datagraph";
    }
};

;// CONCATENATED MODULE: ./components/nav/TopNav.tsx





var TopNav = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref = (0,react.useState)(""), bundleName = ref[0], setBundleName = ref[1];
    (0,react.useEffect)(function() {
        setBundleName(window.location.hostname.split(".")[0]);
    }, []);
    var IconComponent = getIcon(bundleName);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: "sticky-top ".concat((TopNav_module_default())["top-nav"]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "".concat((TopNav_module_default())["bundle-icon"]),
                children: IconComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconComponent, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((TopNav_module_default())["app-title"]),
                children: getTitle(bundleName)
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/layouts/Layout.tsx







var VerticalAlign;
(function(VerticalAlign) {
    VerticalAlign["TOP"] = "v-top";
    VerticalAlign["MIDDLE"] = "v-middle";
    VerticalAlign["BOTTOM"] = "v-bottom";
})(VerticalAlign || (VerticalAlign = {}));
var Layout = function(param) {
    var children = param.children, title = param.title, useBrandBackground = param.useBrandBackground, _verticalAlign = param.verticalAlign, verticalAlign = _verticalAlign === void 0 ? VerticalAlign.TOP : _verticalAlign, embedClass = param.embedClass, userName = param.userName, userEmail = param.userEmail, hideUserBack = param.hideUserBack;
    var variableState = (0,AppContext/* useAppContext */.bp)().variableState;
    var clientName = variableState.clientName || "";
    var brandClassName = useBrandBackground ? (Layout_module_default())[clientName] : "";
    var ogTitle = clientName ? "".concat(capitalize_default()(variableState.clientName), " Connect") : "Pong Enterprise";
    var imagePath = clientName ? "".concat(clientName, "_connect.jpg") : "pong_enterprise.jpg";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "\n      ".concat((Layout_module_default()).container, "\n      ").concat((Layout_module_default())[verticalAlign], "\n      ").concat(brandClassName, "\n    "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title || "Welcome to ".concat(capitalize_default()(variableState.clientName), " onPong!")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width,minimum-scale=1,initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "sentry-trace",
                        content: "{{ span.toSentryTrace() }}"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "shortcut icon",
                        href: "/favicon.ico"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico",
                        sizes: "16x16 32x32 48x48 64x64"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: ogTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: ogTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "/".concat(imagePath)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:type",
                        content: "image/png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:width",
                        content: "400"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:height",
                        content: "300"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:alt",
                        content: ogTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:title",
                        content: ogTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:description",
                        content: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:image",
                        content: "/".concat(imagePath)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: "/favicon-16.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: "/favicon-32.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "64x64",
                        href: "/favicon-64.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "128x128",
                        href: "/favicon-128.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "512x512",
                        href: "/favicon-512.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "120x120",
                        href: "/apple-touch-icon-120.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "152x152",
                        href: "/apple-touch-icon-152.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "/apple-touch-icon-180.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "mask-icon",
                        href: "/safari-pinned-tab.svg",
                        color: "#724ae2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "apple-mobile-web-app-title",
                        content: ogTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-TileColor",
                        content: "#724ae2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-TileColor",
                        content: "windows-tile-144.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "msapplication-config",
                        content: "browserconfig.xml"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "manifest",
                        href: "/site.webmanifest"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "application-name",
                        content: "Pong"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "theme-color",
                        content: "#724ae2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Userback, {
                userName: userName,
                userEmail: userEmail,
                customButton: hideUserBack
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopNav, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: "".concat(embedClass || "", " ").concat((Layout_module_default()).main),
                children: children
            })
        ]
    });
};
/* harmony default export */ var layouts_Layout = (Layout);


/***/ }),

/***/ 10315:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form-actions":"Form_form-actions__Nj41X","save-user":"Form_save-user___W8D4","links":"Form_links__pmkWZ","text-link-children":"Form_text-link-children__gPU8J","subject-required":"Form_subject-required__9RFGt","character-counter":"Form_character-counter__IDhUX","red":"Form_red__H5fY5","count":"Form_count__Kd2Of","login":"Form_login__dvGND","panel":"Form_panel__k_q9g","success-header":"Form_success-header__qQOGr","success-description":"Form_success-description__27zli","success-content":"Form_success-content__wKNyH","success-button":"Form_success-button__io9qv","auth-container":"Form_auth-container__07U0O","form-action":"Form_form-action__n5ngF","description":"Form_description___6wGb","auth-title":"Form_auth-title__m_k6Q"};

/***/ }),

/***/ 87383:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__f8c9j","ennead":"Layout_ennead__4QtHa","ipg":"Layout_ipg__9MZ8k","v-top":"Layout_v-top__LMVjn","v-middle":"Layout_v-middle__V1eX_","v-bottom":"Layout_v-bottom__GzOBU","main":"Layout_main__U7yw4"};

/***/ }),

/***/ 31757:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top-nav":"TopNav_top-nav__DsYbg","bundle-icon":"TopNav_bundle-icon__QKvho","apps":"TopNav_apps__U3oqE","datagraph":"TopNav_datagraph__iGhm1","app-title":"TopNav_app-title__Zuwm1"};

/***/ })

}]);